'use strict';
// This directive is to delay the loading of all DTCM Tracking scripts
// until after AngularJS has has a change to load itself.

namespace Core {
    class DtcmController {
        script: string;
        flagName: string;

        constructor (
            private $element: JQuery,
            private $timeout: ng.ITimeoutService,
            private dtcmService: Core.DtcmService
        ) {}

        $onInit() {
            if (this.dtcmService.isEnabledFlag(this.flagName)) {
                this.$timeout(() => {
                    const script = `<script src="${this.script}" async></script>`;
                    this.$element.append(script);
                }, 1000);
            }
        }
    }

    angular
        .module('core')
        .directive('dtcm', () => {
            return {
                restrict: 'E',
                controllerAs: 'dtcm',
                scope: {},
                bindToController: {
                    script: '@',
                    flagName: '@'
                },
                controller: DtcmController
            };
        });
}
